import {FC, RefObject} from "react";
import PeriodicCard from "../components/cards/PeriodicCard";

interface GlobalLoadingModalProps {
    show: boolean;
    lastTime: number;
    ref: RefObject<HTMLDivElement | null>;
    loadingPercent: RefObject<number | null> | undefined;
}

const GlobalLoadingModal: FC<GlobalLoadingModalProps> = ({ show, lastTime, ref, loadingPercent }) => {
    // console.log("Rendering load", show, Date.now() - lastTime);

    return (
        <div ref={ref} className={`global-loading-overlay ${show ? "" : "hidden"}`}>
            <div className="global-loading-content">
                <div className="spinner"></div>
                <p>Loading Data...</p>
                <PeriodicCard
                    updateInterval={100}
                    updateFunction={(cache: Record<any, any>) => {
                        if (loadingPercent?.current ?? null) {
                            if (loadingPercent.current === (cache?.lastPct ?? false) || loadingPercent.current < 0) {
                                return {};
                            }

                            return { content: <progress value={loadingPercent.current}/>, cache: { lastPct: loadingPercent.current } };
                        }

                        if ((cache?.lastPct ?? true) === false)
                            return { content: <span/>, cache: { lastPct: false } };

                        return {};
                    }}
                />
            </div>
        </div>
    );
};

export default GlobalLoadingModal;
